var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.gmapsAllowed
    ? _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-xl-3 hl hl--2", class: _vm.$bem("label") },
          [_vm._v(_vm._s(_vm.label))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-xl-6", class: _vm.$bem("col-search") },
          [
            _c("SearchBar", {
              class: _vm.$bem("search"),
              on: {
                "geo-search": function ($event) {
                  return _vm.onGeoSearch($event)
                },
                submit: function ($event) {
                  return _vm.updateLocations()
                },
              },
              model: {
                value: _vm.searchTerm,
                callback: function ($$v) {
                  _vm.searchTerm = $$v
                },
                expression: "searchTerm",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-xl-3",
            class: [
              _vm.$bem("col-location"),
              { inactive: !this.canUseLocation },
            ],
          },
          [
            _c(
              "button",
              {
                class: _vm.$bem("location"),
                on: {
                  click: function ($event) {
                    return _vm.sortByUserLocation()
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      baseProfile: "tiny",
                      height: "24",
                      version: "1.2",
                      viewBox: "0 0 24 24",
                      width: "24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10.368 19.102c.349 1.049 1.011 1.086 1.478.086l5.309-11.375c.467-1.002.034-1.434-.967-.967L4.812 12.154c-1.001.467-.963 1.129.085 1.479L9 15l1.368 4.102z",
                      },
                    }),
                  ]
                ),
                _vm._v("\n        Meinen Standort ermitteln\n      "),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: [
                  _vm.$bem("location-subtext"),
                  { hide: !_vm.showLocationHint },
                ],
              },
              [
                _vm._v(
                  "Bitte erlauben Sie die Standortermittlung in Ihrem Browser."
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        !_vm.lookingForLocation && this.locations.size === 0
          ? _c(
              "div",
              {
                class: [_vm.$bem("error"), _vm.$bem("error", "nothing-found")],
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("translate")("error.nothing-found")) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.lookingForLocation
          ? _c(
              "div",
              {
                staticClass: "col-12",
                class: [
                  _vm.$bem("info"),
                  _vm.$bem("info", "location-searching"),
                ],
              },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm._f("translate")("info.location-searching"))
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showResults
          ? _c(
              "div",
              { staticClass: "col-12", class: _vm.$bem("result-list") },
              [
                _vm._l(_vm.shownLocations, function (location) {
                  return [
                    _vm.showResults || location.identifier === _vm.value
                      ? _c("ListItem", {
                          key: location.id,
                          attrs: {
                            favoriteFilter: _vm.favoriteFilter,
                            possibleFavorites: _vm.possibleFavorites,
                            item: location,
                            "show-details-button": false,
                            "show-opening-hours": false,
                            "show-address": false,
                            "fav-selects-item": true,
                          },
                          on: { click: () => _vm.onSelectItem(location) },
                        })
                      : _vm._e(),
                  ]
                }),
                _vm._v(" "),
                _vm.storeLocation
                  ? _c("div", { class: _vm.$bem("footnotes") }, [
                      _vm.storeLocation
                        ? _c("span", [_vm._v("* Lagerstandort")])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showResults && _vm.limitationOfLocationsEnabled
                  ? _c("div", { class: _vm.$bem("show-more") }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--prim",
                          on: {
                            click: function ($event) {
                              return _vm.showMore()
                            },
                          },
                        },
                        [_vm._v("\n          Alle anzeigen\n        ")]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ])
    : !_vm.gmapsAllowed
    ? _c("div", { staticClass: "mb-4", class: _vm.$bem("consent-info") }, [
        _c("p", [
          _vm._v(
            "Um einen Markt auswählen zu können, brauchen wir die Erlaubnis von Ihnen auf Google Maps zugreifen zu dürfen."
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn--prim",
            attrs: { href: "JavaScript:void(0)" },
            on: {
              click: function ($event) {
                return _vm.openTagManager()
              },
            },
          },
          [
            _c("span", { staticClass: "btn__inner" }, [
              _vm._v("Zu den Datenschutz-Einstellungen"),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }